<div ngbDropdown display="dynamic" placement="bottom-end">
  <button type="button"
    class="btn d-flex justify-content-between w-100 {{ isDisabled ? 'disabled' : '' }}"
    ngbDropdownToggle>
    <span *ngIf="showIcon" class="icon"><i class="bi bi-{{ iconName }}"></i></span>
    <div class="inner d-flex justify-content-between w-100">
      <span class="text-gray-600" *ngIf="!selectedLocation">{{ title }}</span>
      <span *ngIf="selectedLocation" class="text-dark">{{ selectedLocation.lat }},{{ selectedLocation.lng }}</span>
      <span>
        <span class="ms-2">
          <app-ac-icon-arrow-down></app-ac-icon-arrow-down>
        </span>
      </span>
    </div>
  </button>
  <div ngbDropdownMenu class="w-100 map-dropdown">
    <ngx-place-picker [enablePlacesSearch]="true" [enableCurrentLocation]="enableCurrentLocation"
      (locationChanged)="locationChange($event)" [vSize]="100">
    </ngx-place-picker>
  </div>
</div>
